<template>
  <div v-if="isOpen" class="modal fade show" aria-labelledby="addNewCardTitle"
       style="display: block; background: #1c1d1c33">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-between px-1 my-1 align-item-center">
              <h1 class="mb-0">{{ modalTitle }}</h1>
              <button
                  @click="toggleModal"
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
              ></button>
            </div>
          </div>
        </div>
        <hr class="mt-0">

        <div class="pb-2">
          <!-- form -->
          <form @submit.prevent="handleSubmit">
            <div class="row gy-2 px-2">

              <div class="col-12" v-if="type == 'item' && projectAccountLevel == 'account'">
                <label class="form-label" for="linked_item">Linked Product or Service</label>
                <div>
                  <AsyncSelect
                      placeholder="Select Product"
                      :model-value="selectedProductObject"
                      @update:modelValue="val => { selectedProductObject = val }"
                      :api-service="fetchProductList"
                      label="text"
                      :format-label="opt => (opt.text || opt.name) + (opt.id ? ' (' + opt.id + ')' : '')"
                      :reduce="opt => opt"
                      :additional-query="additionalProductQuery"
                  />
                  <ErrorMessage name="name" class="invalid-feedback d-block qcont"/>
                </div>
              </div>

              <div class="col-12" v-show="type != 'item' && projectAccountLevel == 'account'">
                <label class="form-label" for="linked_item">Linked Account Head</label>
                <div>
                  <v-select
                      placeholder="Select Account Head"
                      v-model="form.linked_account_id"
                      :options="accountHeads"
                      label="name"
                      :reduce="name => name.id"
                  />
                  <ErrorMessage name="name" class="invalid-feedback d-block qcont"/>
                </div>
              </div>

              <div class="col-12">
                <label class="form-label" for="linked_item">Name</label>
                <div class="input-group">
                  <input type="text"
                         class="form-control form-control-sm"
                         name="name"
                         v-model="form.name"
                  >
                  <ErrorMessage name="name" class="invalid-feedback d-block qcont"/>
                </div>
              </div>

              <div class="col-12">
                <label class="form-label" for="linked_item">Code</label>
                <div class="input-group">
                  <input type="text"
                         class="form-control form-control-sm"
                         name="code"
                         v-model="form.code"
                  >
                  <ErrorMessage name="code" class="invalid-feedback d-block qcont"/>
                </div>
              </div>

              <div class="col-12">
                <label class="form-label" for="linked_item">Description</label>
                <div class="input-group">
                  <input type="text"
                         class="form-control form-control-sm"
                         name="description"
                         v-model="form.description"
                  >
                  <ErrorMessage name="description" class="invalid-feedback d-block qcont"/>
                </div>
              </div>

              <div class="col-12" v-if="!showParent">
                <label class="form-label" for="exp_account_type">Exp Account Type</label>
                <div>
                  <select class="form-control" v-model="form.exp_account_type" id="exp_account_type">
                    <option value="expense">Expense</option>
                    <option value="income">Income</option>
                  </select>
                  <ErrorMessage name="exp_account_type" class="invalid-feedback d-block qcont"/>
                </div>
              </div>

              <div class="col-12" v-show="type != 'item' && projectAccountLevel == 'account'">
                <label class="form-label" for="linked_item">Linked FD6 Account Head</label>
                <div>
                  <v-select
                    placeholder="Select FD6 Account Head"
                    v-model="form.fd6_account_id"
                    :options="fd6AccountHeads"
                    label="name"
                    :reduce="name => name.id"
                  />
                  <ErrorMessage name="name" class="invalid-feedback d-block qcont"/>
                </div>
              </div>

              <div class="col-12" v-show="type != 'item' && projectAccountLevel == 'account'">
                <label class="form-label" for="linked_item">Linked Program</label>
                <div>
                  <v-select
                    placeholder="Select Program"
                    v-model="form.program_id"
                    :options="programs"
                    label="name"
                    :reduce="name => name.id"
                  />
                  <ErrorMessage name="name" class="invalid-feedback d-block qcont"/>
                </div>
              </div>

              <div v-if="showParent" class="col-md-12">
                <label class="form-label">Parent Group</label>
                <v-select
                    v-model="form.project_account_id"
                    label="name"
                    :options="accounts"
                    :reduce="name => name.id"
                />
              </div>

              <div class="col-12" v-show="(accountType == 'activity_budget' || accountType == 'activity_target' || accountType == 'activity')">
                <label class="form-label" for="linked_item">Project Type</label>
                <div>
                  <v-select
                      placeholder="Select Type"
                      v-model="form.project_type"
                      :options="projectTypeArr"
                      label="name"
                      :reduce="name => name.id"
                  />
                </div>
              </div>

              <div class="col-12" v-show="projectAccountLevel == 'account'">
                <label class="form-label" for="linked_item">Measurement Type</label>
                <div>
                  <v-select
                      placeholder="Select Measurement Type"
                      v-model="form.unit_id"
                      :options="unitList"
                      label="name"
                      :reduce="name => name.id"
                  />
                </div>
              </div>


              <div class="col-12">
                <label class="form-label" for="status">Status</label>
                <div>
                  <v-select
                      placeholder="Select Status"
                      v-model="form.status"
                      :options="statusOptions"
                      label="name"
                      :reduce="name => name.id"
                  />
                  <ErrorMessage name="status" class="invalid-feedback d-block qcont"/>
                </div>
              </div>
            </div>

            <div class="col-12 text-center">
              <hr class="mt-2">
              <button :disabled="loading" type="submit"
                      class="btn btn-primary me-1 mt-1 waves-effect waves-float waves-light">
                <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                Submit
              </button>
              <button @click.prevent="toggleModal" class="btn btn-outline-secondary mt-1 waves-effect">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import handlePurchaseAndSales from "@/services/modules/purchase";
import handleDropdowns from "@/services/modules/dropdowns";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";

export default {
  name: "AccountGroupModal",

  components: {
    AsyncSelect
  },

  props: {
    modalTitle: {
      type: String,
    },
    form: {
      type: Object,
    },
    showParent: {
      type: Boolean,
    },
    query: {
      type: String,
    },
    types: {
      type: Object,
    },
    accountType: {
      type: String,
    },
    projectId: {
      required: true,
    },
    accounts: {
      type: Array,
    },
    projectAccountLevel: {
      type: String,
    },
    isFD6: {
      type: Boolean,
      default: false
    },
    ngoDefaultAccountTypes: {
      type: Array,
      default: []
    },
    projectType: {
      type: Object,
    },
    projectAccountStatus: {
      type: Object,
    },
    unitList: {
      type: Array,
    },
    accountHeads: {
      type: Array,
      default: () => []
    },
    fd6AccountHeads: {
      type: Array,
      default: () => []
    },
    programs: {
      type: Array,
      default: () => []
    },
  },

  data: () => ({
    isOpen: false,
    loading: false,
    selectedProductObject: null,
  }),

  computed: {
    statusOptions() {
      return this.projectAccountStatus ? Object.entries(this.projectAccountStatus).map(([id, name]) => {
        return { id, name }
      }) : [];
    },
    typeArr() {
      return this.types ? Object.entries(this.types).map((el) => {
        return {
          id: el[0],
          name: el[1],
        }
      }) : [];
    },

    companyId() {
      return this.$route.params.companyId;
    },

    type() {
      return this.form.project_account_type;
    },

    projectTypeArr() {
      return this.projectType ? Object.keys(this.projectType).map((id) => {
        return {
          id: id,
          name: this.projectType[id],
        }
      }) : [];
    },

    additionalProductQuery() {
      return {
        account_type: this.type
      }
    }
  },

  methods: {
    toggleModal() {
      if (this.isOpen) {
        this.selectedProductObject = null;
        this.$emit("onCloseGroupModal");
        this.isOpen = false;
        return;
      }

      let type = this.accountType;
      if (type === 'activity_budget' || type === 'activity_target') {
        type = 'activity';
      }
      if (this.accountType === 'activity_target' && !this.form.id) {
        this.form.project_type = 'task';
      }
      this.form.project_account_type = type;
      this.isOpen = true;
    },

    async handleSubmit() {
      this.$emit('onAccountSave');
    },

    onSelectProduct(product) {
      if (this.form.name) return;
      if (product) {
        this.form.name = product.text || product.name || '';
      }
    },

    getBudgetHead(value, heads) {
      if (this.form.name) return;

      const findHead = heads.find(el => el.id == value);
      this.form.name = '';
      if (findHead) {
        this.form.name = findHead.name || findHead.text || '';
      }
    },
  },

  watch: {
    isOpen: function (newVal) {
      if (newVal && this.form.linked_item_id) {
        this.selectedProductObject = {
          id: this.form.linked_item_id,
          text: this.form.product_name || this.form.name
        };
      }
    },
    selectedProductObject: function (newVal) {
      if (newVal) {
        this.form.linked_item_id = newVal.id;
        this.onSelectProduct(newVal);
        return;
      }
      this.form.linked_item_id = null;
    },
    'form.linked_item_id': function (newVal) {
      if (!newVal) {
        this.selectedProductObject = null;
      }
    },
    'form.linked_account_id': function (newVal) {
      if (!newVal) return;
      this.getBudgetHead(newVal, this.accountHeads);
    },
    'form.project_account_type': function (newVal) {
      if (newVal == 'item') {
        this.form.linked_account_id = "";
        return;
      }
      this.form.linked_item_id = "";
    }
  },

  setup() {
    const {fetchProductList} = handlePurchaseAndSales();
    const {fetchDropdownList} = handleDropdowns();

    return {
      fetchProductList,
      fetchDropdownList,
    }
  },
}
</script>

<style scoped>

</style>
